export enum BOTTOM_SHEET_VIEWS {
  AvoidCuts = 'AvoidCuts',
  LookupOptions = 'LookupOptions',
  LookupsList = 'LookupsList',
  Upselling = 'Upselling',
  Adjustments = 'Adjustments',
  PrivacyPolicy = 'PrivacyPolicy',
  PhotoDrawer = 'PhotoDrawer',
  SourceUpload = 'SourceUpload',
  SaveProject = 'SaveProject',
  Login = 'Login',
  DiscountTable = 'DiscountTable',
  SharePhotos = 'SharePhotos',
  GroupTabs = 'GroupTabs',
}

export const BOTTOM_SHEET_DEFAULT_VALUES = {
  bottomSheetVisible: false,
  bottomSheetTitle: '',
  bottomSheetView: BOTTOM_SHEET_VIEWS.LookupOptions,
  bottomSheetLookupsSecondLevel: [],
  bottomSheetLookupOptions: [],
  isSecondLevelLookup: false,
  bottomSheetData: {},
  showOpacityBackground: true,
  showDragIndicator: true,
  contentViewStyle: {},
  suggestedFormatCard: {
    productConfigurationId: '',
    code: '10x13',
    aspectRatio: 1,
    isSuggested: true,
    price: 0,
    title: '',
  },
};
